import DataRequest from "./DataRequest";
import { useQuery } from "react-query";
import { NotableItem } from "../types/responses/gradingResponse";

export const useNotableItems = (inspectionId: string, user: any) => {
    return useQuery<NotableItem[]>("notableItems", async () => {
        return await DataRequest(inspectionId, "notable-items", user);
    });
};

export const useDefects = (inspectionId: string, user: any) => {
    return useQuery<NotableItem[]>("defects", async () => {
        return await DataRequest(inspectionId, "defects", user);
    });
};
